import { render, staticRenderFns } from "./PayrollMovementList.vue?vue&type=template&id=bfadb32e"
import script from "./PayrollMovementList.vue?vue&type=script&lang=js"
export * from "./PayrollMovementList.vue?vue&type=script&lang=js"
import style0 from "./PayrollMovementList.vue?vue&type=style&index=0&id=bfadb32e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports